export const Reminder = (type) => {

  let rules = {
    "password": "Password must have at least 8 characters and contain at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character.",
  };
  
    return rules[type] || "";
  };
